import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import init from './libs/init'
import * as ModalDialogs from 'vue-modal-dialogs'
import './libs/filters'

import VueGtag from 'vue-gtag'

import Tooltip from './directives/tooltip'
import AutoFitText from './directives/autoFitText'

import { getAuthToken } from '@/libs/auth-helper'
import { parseJwt } from '@/libs/utils'

Vue.config.productionTip = false
Vue.use(ModalDialogs)

Vue.use(Tooltip, {
  maxWidth: 300,
  theme: 'light',
  direction: 'top', // top | bottom | left | right
  align: 'center' // start | center | end
})

Vue.use(AutoFitText)

Vue.use(VueGtag, {
  config: {
    id: 'AW-835556530'
  }
})

if (['reboot.beusable.net', 'tool.beusable.net'].indexOf(location.hostname) !== -1) {
  if (console && console.log) {
    console.log = () => {}
    console.error = () => {}
  }
}

if (getAuthToken()) {
  const token = getAuthToken()
  const tokenInfo = parseJwt(token)
  if (tokenInfo && tokenInfo.identity && tokenInfo.identity.user_num) {
    window._beu_custom_user_id = tokenInfo.identity.user_num
  }
}

const i18n = init()

window.__VUE_ROOT__ = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
